import { IconButton, Menu, MenuItem, MenuProps } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";

interface IconWithDropdownrops {
  onEdit?: () => void;
  onRemove?: () => void;
  customItems?: { label: string; onClick: () => void }[];
  menuProps?: Partial<MenuProps>;
}

export const IconWithDropdown = ({
  onEdit,
  onRemove,
  customItems = [],
  menuProps,
}: IconWithDropdownrops) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action: () => void) => {
    action();
    handleClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        {...menuProps}
      >
        {onEdit && (
          <MenuItem onClick={() => handleAction(onEdit)}>Edit</MenuItem>
        )}
        {onRemove && (
          <MenuItem onClick={() => handleAction(onRemove)}>Remove</MenuItem>
        )}
        {customItems.map((item, idx) => (
          <MenuItem key={idx} onClick={() => handleAction(item.onClick)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
